export const DELETE_WISHLIST = /* GraphQL */ `
    mutation deleteWishlist($wishlistId: ID!) {
        deleteWishlist(wishlistId: $wishlistId) {
            status
        }
    }
`
